module.exports = __webpack_public_path__ + "static/img/indexnew.6bfb1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/indexnew.png
// module id = jP/3
// module chunks = 44